import * as React from "react";
import { ProductModal } from "./ProductModal";

interface ProductModalContextType {
  openModal: (product: {
    id: string | number;
    image: string;
    tag: string;
    logo: string;
    title?: string;
    description?: string;
  }) => void;
  closeModal: () => void;
}

const ProductModalContext = React.createContext<ProductModalContextType | null>(
  null
);

export const useProductModal = () => {
  const context = React.useContext(ProductModalContext);
  if (!context) {
    return {
      openModal: () => {
        console.warn("ProductModalProvider not found. Modal will not open.");
      },
      closeModal: () => {
        console.warn("ProductModalProvider not found. Modal will not close.");
      },
    };
  }
  return context;
};

export const ProductModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [modalState, setModalState] = React.useState<{
    isOpen: boolean;
    product: {
      id: string | number;
      image: string;
      tag: string;
      logo: string;
      title?: string;
      description?: string;
    } | null;
  }>({
    isOpen: false,
    product: null,
  });

  const openModal = React.useCallback(
    (product: {
      id: string | number;
      image: string;
      tag: string;
      logo: string;
      title?: string;
      description?: string;
    }) => {
      setModalState({ isOpen: true, product });
    },
    []
  );

  const closeModal = React.useCallback(() => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  }, []);

  return (
    <ProductModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      {modalState.product && (
        <ProductModal
          isOpen={modalState.isOpen}
          onClose={closeModal}
          {...modalState.product}
        />
      )}
    </ProductModalContext.Provider>
  );
};
